/**
 * @prettier
 * @flow
 */
import { KEY_NAME } from 'src/utils/localstorage/getDeviceInLocaleStorage';

export function setDeviceInLocaleStorage(value: string): void {
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value ?? ''));
}
